import api from './axios';

export async function subscribeAlumni(payload) {
  const { data } = await api.post('/alumni', payload);
  return data;
}

export async function fetchAlumni(params = {}) {
  const { data } = await api.get('/alumni', { params });
  return data.alumni || [];
}

export async function exportAlumni(params = {}) {
  const response = await api.get('/alumni/export', {
    params,
    responseType: 'blob',
  });
  return response.data;
}

export async function getCountries() {
  const { data } = await api.get('/alumni/countries');
  return data.countries || [];
}
